export function getAgentHubExperienceType(experience: App.ExperienceOffer): App.ProductType {
  switch (experience.productType) {
    case 'transfer':
      return 'transfer'
    default:
      return 'experience'
  }
}

export function getAgentHubCommissionItemKey(item: App.Checkout.AnyItem | App.Checkout.AnyItemBreakdownView, cartItems: Array<App.Checkout.AnyItem | App.Checkout.AnyItemBreakdownView>): string {
  const transactionKey = item.transactionKey

  if ('experienceId' in item && item.itemType === 'experience') {
    return transactionKey + '-' + item.experienceId
  }

  if (item.itemType === 'tourV2Experience' && 'purchasableOption' in item) {
    return cartItems.find(cartItem => cartItem.itemType === 'tourV2' && cartItem.offerId === item.offerId)?.transactionKey + '-' + item.purchasableOption.fkExperienceId
  }

  if ('offerId' in item) {
    return transactionKey + '-' + item.offerId
  }
  return transactionKey!
}

const TIER_ORDER: Array<App.AgentHubTier> = ['tier1', 'tier2', 'tier3']

export function isAgentTierGreaterOrEqualTo(agentTier: App.AgentHubTier, requiredTier: App.AgentHubTier): boolean {
  return TIER_ORDER.indexOf(agentTier) >= TIER_ORDER.indexOf(requiredTier)
}
